import Config from "../components/common/Config";
const user_id = localStorage.getItem("userId");
const accessToken = localStorage.getItem("accessToken");
const token = localStorage.getItem("token");

export const setTableWidths = async (user_id, table_name, widths = []) => {
    try {
        const formData = new FormData();
        formData.append('table_name', table_name);
        formData.append('widths', JSON.stringify(widths));
        const response = await fetch(`${Config.API_URL}/settings/ws-set-user-table-settings/${user_id}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken || ''}`,
            },
            body: formData,
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
}
export const getTableWidths = async (user_id, table_name) => {
    try {
        const formData = new FormData();
        formData.append('table_name', table_name);
        const response = await fetch(`${Config.API_URL}/settings/ws-get-user-table-settings/${user_id}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token || ''}`,
            },
            body: formData,
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
}

export const setTableColumnVisibility = async (user_id, table_name, column_visibility) => {
    try {
        const response = await fetch(`${Config.API_URL}/settings/ws-set-user-table-column-settings/${user_id}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken || ''}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                table_name: table_name,
                column_visibility: column_visibility,
            }),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error('Error setting column visibility:', error);
        throw error;
    }
}

export const getTableColumnVisibility = async (user_id, table_name) => {
    try {
        const response = await fetch(`${Config.API_URL}/settings/ws-get-user-table-column-settings/${user_id}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${ token || ''}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                table_name: table_name,
            })
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error('Error getting column visibility:', error);
        throw error;
    }
}